export async function sendMessage(form) {
    try {
        const response = await fetch('./send-message.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });
        const result = await response.json();

        if (result.ok === true) {
            if (typeof ym !== 'undefined') {
                ym(106816586, 'reachGoal', 'send');
                console.log('Цель отправлена успешно!')
            } else {
                console.error('Метрика не загружена или заблокирована');
            }
            return true;
        } else {
            console.error('Ошибка при отправке сообщения');
        }
        return false;
    } catch (error) {
        console.error('Ошибка отправки сообщения:', error);
        return false;
    }
}